import { Component } from "@angular/core";

@Component({
  selector: "app-agency-policies",
  templateUrl: "./agency-policies.component.html",
  styleUrls: ["./agency-policies.component.css"],
})
export class AgencyPoliciesComponent {}
